import React, { useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import HtmlPdfDocument from "./HtmlPdfDocument";

const HtmlPdf = ({ data, cleanUpfunction, fileName, forcePrint = false ,batchEditHistory}) => {
  const componentRef = useRef();

  useEffect(() => {
    if (fileName !== null) document.title = fileName;
    document.title = "Batch Manager";
    document.getElementById("print-button").click();
  }, [data, forcePrint]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <ReactToPrint
        trigger={() => <button id="print-button"></button>}
        content={() => componentRef.current}
        documentTitle={fileName}
        onAfterPrint={() => {
          document.title = "VLP Extend";
          if (cleanUpfunction !== null && typeof cleanUpfunction === "function") {
            cleanUpfunction();
          };
        }}
      />
      <HtmlPdfDocument data={data} fileName={fileName} ref={componentRef} batchEditHistory={batchEditHistory} />
    </div>
  );
};

export default HtmlPdf;
